export default {
  loading: false,
  data: null,
  error: null,
  selected: null,
  category: null,
};
